import type {
  Identified,
  SoftDeletable,
  VersionedEntity
} from "../../shared/kernel/entity.js";
import type { UtcDateTime } from "../../shared/kernel/date-time.js";
import type { UserId } from "../../shared/kernel/identifiers.js";

export enum UserStatus {
  Invited = "INVITED",
  Active = "ACTIVE",
  Blocked = "BLOCKED",
  Inactive = "INACTIVE"
}

export interface User
  extends Identified<UserId>, VersionedEntity, SoftDeletable {
  readonly email: string;
  readonly name: string;
  readonly login?: string;
  readonly username?: string;
  /**
   * @deprecated LEGADO — senha em texto puro. Nada grava mais este campo; ele
   * existe só para ler cadastros antigos, e o primeiro login de cada usuário
   * o apaga (ver AdminService.authenticateByCredentials). Nunca voltar a
   * preenchê-lo: a senha vive derivada em `passwordHash`.
   */
  readonly password?: string | undefined;
  /** Senha derivada pelo mecanismo oficial — ver domain/identity/password-hash.ts. */
  readonly passwordHash?: string | undefined;
  readonly status: UserStatus;
  readonly authenticationId?: string | null;
  readonly lastLoginAt: UtcDateTime | null;
  readonly lastAccessAt?: UtcDateTime | null;
  readonly photoUrl?: string;
  /**
   * Reference to the stored profile photo (the bytes live apart, keyed by
   * userId). Independent from Professional.signatureImageId — see
   * domain/identity/user-avatar.ts.
   */
  readonly profileImageId?: string | null;
  readonly profileType?: string;
  readonly professionalId?: string;
  readonly customPermissions?: readonly string[];
}
